<template>
  <v-dialog v-model="dialog" max-width="640px" persistent scrollable>
    <v-card>
      <v-card-title class="d-flex align-center">
        <span class="text-h5">同意紀錄詳情</span>
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-4">
        <OptLogDetailsForm v-if="dialog && id" ref="form" :key="id" :id="id" @cancel="close" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import OptLogDetailsForm from './OptLogDetailsForm';

export default {
  name: 'OptLogDetailsDialog',
  components: {
    OptLogDetailsForm,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
  },
};
</script>
